import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Form,
  FormGroup,
  FormFeedback,
} from 'reactstrap';
import { downloadBulkReport, downloadDetailedReport } from '../../../actions/tests/apiRequests';
import Button from '../../shared/Button';
import Checkbox from '../../shared/Checkbox';
import DatePicker from '../../shared/DatePicker';
import styles from './styles.scss';
import { saveAs } from 'file-saver';
import { notifyError } from '../../../utils/notifier';
import Modal from '../../shared/Modal';

const MIN_QUERY_LENGTH = 2;
const MAX_QUERY_LENGTH = 100;

class TestsListFilters extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingHRR: false,
      loadingBR: false,
      showModal: false,
      reportType: '',
    };

    this.bulkReport = this.bulkReport.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.switchCompletedFilter = this.switchCompletedFilter.bind(this);
    this.toggleComfirmationModal = this.toggleComfirmationModal.bind(this);
    this.showModalConfirmation = this.showModalConfirmation.bind(this);
    this.cancelComfirmationModal = this.cancelComfirmationModal.bind(this);
  }

  static get propTypes() {
    return {
      onSubmit: PropTypes.func,
      onChange: PropTypes.func,
      isSpruceAdmin: PropTypes.bool,
      filters: PropTypes.object,
      loading: PropTypes.bool,
      clearFilters: PropTypes.func,
    };
  }

  detailedReport() {
    const { filters: filter } = this.props;

    this.setState({ loadingHRR: true });

    return downloadDetailedReport(filter)
      .then((blob) => saveAs(blob, 'detailedExport.csv'))
      .catch(() => notifyError())
      .finally(() => this.setState({ loadingHRR: false }));
  }

  bulkReport() {
    const { filters: filter } = this.props;

    this.setState({ loadingBR: true });

    return downloadBulkReport(filter)
      .then((blob) => saveAs(blob, 'bulkExport.csv'))
      .catch(() => notifyError())
      .finally(() => this.setState({ loadingBR: false }));
  }

  onSubmit(e) {
    e.preventDefault();
    this.props.onSubmit();
  }

  switchCompletedFilter(e) {
    const {
      filters: { completed },
      onChange,
    } = this.props;
    const value = e.target.value === 'completed';

    onChange('completed', completed === value ? null : value);
  }

  showModalConfirmation(reportType) {
    const { showModal } = this.state;
    this.setState({ showModal: !showModal, reportType: reportType });
  }

  toggleComfirmationModal() {
    const { showModal, reportType } = this.state;
    this.setState({ showModal: !showModal, reportType: '' });

    switch (reportType) {
      case 'hourly read': {
        this.detailedReport();
        break;
      }
      case 'bulk': {
        this.bulkReport();
        break;
      }
    }
  }

  cancelComfirmationModal() {
    const { showModal } = this.state;
    this.setState({
      loadingHRR: false,
      loadingBR: false,
      showModal: false,
    });
  }

  render() {
    const {
      isSpruceAdmin,
      filters: {
        ClientName,
        Email,
        PostalCode,
        Address,
        TesterName,
        TestId,
        Start,
        End,
        CustomerNumber,
        SerialNumber,
        completed,
        qc,
      },
      onChange,
      loading,
      clearFilters,
    } = this.props;

    const { loadingHRR, loadingBR, showModal, reportType } = this.state;

    let reportText = '';
    switch (reportType) {
      case 'hourly read': {
        reportText = 'an hourly read';
        break;
      }
      case 'bulk': {
        reportText = 'a bulk';
        break;
      }
    }

    return (
      <Container fluid={true} className="col-md-9 col-md-offset-2">
        <Form onSubmit={this.onSubmit}>
          <Row>
            <Col lg={4} xl={4} className="mb-2">
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText className={styles.searchIcon}>
                      <i className="fa fa-search" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    className={styles.search}
                    value={Address}
                    placeholder="Address"
                    onChange={(event) => onChange('Address', event.target.value)}
                  />
                  <FormFeedback className="text-left">
                    {`Search query should contain from ${MIN_QUERY_LENGTH} to ${MAX_QUERY_LENGTH} characters`}
                  </FormFeedback>
                </InputGroup>
              </FormGroup>
            </Col>
            <Col lg={2} xl={2} className="mb-2">
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText className={styles.searchIcon}>
                      <i className="fa fa-search" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    className={styles.search}
                    value={PostalCode}
                    placeholder="Postal Code"
                    onChange={(event) => onChange('PostalCode', event.target.value)}
                  />
                  <FormFeedback className="text-left">
                    {`Search query should contain from ${MIN_QUERY_LENGTH} to ${MAX_QUERY_LENGTH} characters`}
                  </FormFeedback>
                </InputGroup>
              </FormGroup>
            </Col>
            <Col lg={3} xl={3} className="mb-2">
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText className={styles.searchIcon}>
                      <i className="fa fa-search" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    className={styles.search}
                    value={ClientName}
                    placeholder="Client Name"
                    onChange={(event) => onChange('ClientName', event.target.value)}
                  />
                  <FormFeedback className="text-left">
                    {`Search query should contain from ${MIN_QUERY_LENGTH} to ${MAX_QUERY_LENGTH} characters`}
                  </FormFeedback>
                </InputGroup>
              </FormGroup>
            </Col>
            <Col lg={3} xl={3} className="mb-2">
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText className={styles.searchIcon}>
                      <i className="fa fa-search" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    className={styles.search}
                    value={Email}
                    placeholder="Client Email"
                    onChange={(event) => onChange('Email', event.target.value)}
                  />
                  <FormFeedback className="text-left">
                    {`Search query should contain from ${MIN_QUERY_LENGTH} to ${MAX_QUERY_LENGTH} characters`}
                  </FormFeedback>
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col lg={3} xl={3} className="mb-2">
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText className={styles.searchIcon}>
                      <i className="fa fa-search" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    className={styles.search}
                    value={TesterName}
                    placeholder="Tester Name"
                    onChange={(event) => onChange('TesterName', event.target.value)}
                  />
                  <FormFeedback className="text-left">
                    {`Search query should contain from ${MIN_QUERY_LENGTH} to ${MAX_QUERY_LENGTH} characters`}
                  </FormFeedback>
                </InputGroup>
              </FormGroup>
            </Col>

            <Col lg={3} xl={3} className="mb-2">
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText className={styles.searchIcon}>
                      <i className="fa fa-search" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    className={styles.search}
                    value={TestId}
                    placeholder="Test Id"
                    onChange={(event) => onChange('TestId', event.target.value)}
                  />
                  <FormFeedback className="text-left">
                    {`Search query should contain from ${MIN_QUERY_LENGTH} to ${MAX_QUERY_LENGTH} characters`}
                  </FormFeedback>
                </InputGroup>
              </FormGroup>
            </Col>
            <If condition={isSpruceAdmin}>
              <Col lg={3} xl={3} className="mb-2">
                <FormGroup>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText className={styles.idCardIcon}>
                        <i className="fa fa-id-card" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      className={styles.customer}
                      value={CustomerNumber}
                      onChange={(event) => onChange('CustomerNumber', event.target.value)}
                      placeholder="Customer number"
                    />
                  </InputGroup>
                </FormGroup>
              </Col>
            </If>
            <Col lg={3} xl={3} className="mb-2">
              <FormGroup>
                <InputGroup>
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText className={styles.deviceIcon}>
                      <i className="fa fa-hdd-o" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    className={styles.device}
                    value={SerialNumber}
                    onChange={(event) => onChange('SerialNumber', event.target.value)}
                    placeholder="Device Serial Number"
                  />
                </InputGroup>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col sm={6} xl={2} className="mb-2 text-left">
              <FormGroup>
                <DatePicker
                  time={false}
                  placeholder="Start Date"
                  value={Start}
                  onChange={(value) => onChange('Start', value)}
                  max={End}
                />
              </FormGroup>
            </Col>
            <Col sm={6} xl={2} className="mb-2 text-left">
              <FormGroup>
                <DatePicker
                  time={false}
                  placeholder="End Date"
                  value={End}
                  onChange={(value) => onChange('End', value)}
                  min={Start}
                />
              </FormGroup>
            </Col>
            <Col sm={6} xl={4} className="mb-2 text-left">
              <div className={`align-items-center ${styles.filtersContainer}`}>
                <span className="font-weight-bold mr-1">Status:</span>
                <input
                  className="mr-1"
                  type="radio"
                  name="status"
                  checked={completed === true}
                  value="completed"
                  id="completed"
                  onClick={this.switchCompletedFilter}
                />
                <label htmlFor="completed" className="mt-2 mr-1">
                  Complete
                </label>
                <input
                  className="mr-1"
                  type="radio"
                  name="status"
                  checked={completed === false}
                  value="incompleted"
                  id="incompleted"
                  onClick={this.switchCompletedFilter}
                />
                <label htmlFor="incompleted" className="mt-2 mr-1">
                  Incomplete
                </label>
                <Checkbox checked={qc} onChange={(value) => onChange('qc', value || null)} />
                <span className="mr-1">QC</span>
              </div>
            </Col>
          </Row>
          <Row>
            <If condition={isSpruceAdmin}>
              <Col xs={4} sm={3} xl={3} className="mb-2">
                <Button
                  type="button"
                  className={`mb-2 ${styles.reportButton}`}
                  disabled={loadingHRR}
                  onClick={() => this.showModalConfirmation('hourly read')}
                >
                  <div className={styles.reportButtonText}>
                    {loadingHRR ? <i className="fa fa-spin fa-spinner" /> : 'Hourly Readings'}
                  </div>
                </Button>
              </Col>
            </If>
            <Col xs={4} sm={3} xl={3} className="mb-2">
              <Button
                type="button"
                className={`mb-2 ${styles.reportButton}`}
                disabled={loadingBR}
                onClick={() => this.showModalConfirmation('bulk')}
              >
                <div className={styles.reportButtonText}>
                  {loadingBR ? <i className="fa fa-spin fa-spinner" /> : 'Bulk Report'}
                </div>
              </Button>
            </Col>
            <Col xs={4} sm={3} xl={3} className="mb-2">
              <Button type="button" className={`mb-2 ${styles.reportButton}`} onClick={() => clearFilters()}>
                <div className={styles.reportButtonText}>Clear Filters</div>
              </Button>
            </Col>
            <Col xs={4} sm={3} xl={3} className="mb-2">
              <Button type="submit" kind="danger" className={`mb-2 ${styles.submitButton}`} disabled={loading}>
                {loading ? <i className="fa fa-spin fa-spinner" /> : 'Submit'}
              </Button>
            </Col>
          </Row>
          <Modal
            header={'Continue to generate report?'}
            isOpen={showModal}
            onConfirm={this.toggleComfirmationModal}
            onCancel={this.cancelComfirmationModal}
          >
            {`Are you sure you want to receive ${reportText} report? It can take a long time`}
          </Modal>
        </Form>
      </Container>
    );
  }
}

export default TestsListFilters;



// WEBPACK FOOTER //
// src/components/testsList/TestsListFilters/index.jsx